module.exports = __webpack_public_path__ + "static/media/product-local-area-photo.9e775e10.svg";